export const getStore = state => state.monitoredDocument || {};

export const getMonitoredDocument = state => getStore(state).monitoredDocument || {};

export const isFetching = state => getStore(state).fetching;
export const isFetched = state => getStore(state).fetched;
export const hasFailed = state => getStore(state).failed;
